<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <ProgressBar />
    <PageHeading :default-heading="pd_content.page_header" />
    <form @submit.prevent>
      <div class="pvd-container container-divider">
        <p v-html="pd_content.confirmation_text" />
      </div>
      <NavigationComponent />
    </form>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';

export default {
  name: 'FinalPage',
  components: {
    NavigationComponent,
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    document.title = this.setTitle(this.pd_content.page_header);
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
};
</script>

<style scoped>

</style>
